

































































































































































import { Component, Vue, Prop, Inject } from 'vue-property-decorator';
import { GQL_newInvoiceData_newInvoice } from '@/queries/__generated__/newInvoiceData';
import Invoice from './Invoice.vue';
import { parseAccountingCost } from '@/app/Order';

@Component
export default class InvoiceInfo extends Vue {
  @Prop(Object) public invoice!: GQL_newInvoiceData_newInvoice;
  @Prop({ type: String, default: 'full' }) public mode!: 'full' | 'minimal';
  @Inject() public documentComponent!: Invoice;

  // TODO: When we have requirements to support other country invoices, implement this to be read from bankAccounts.
  public bankAccountCountryCode = 'NO';

  private updateDuedate(issueDate: string) {
    const creditDays = this.invoice.customer.creditDays;
    this.invoice.dueDate = this.$dayjs.strict(issueDate).add(creditDays, 'days').format('YYYY-MM-DD');
  }

  get editable() {
    return this.documentComponent.reactiveProps.editable;
  }

  public accountingCost() {
    // Several orders have no single accounting cost: '' shows none, where
    // null would fall back to the live values.
    if (this.invoice.orders.length !== 1) return parseAccountingCost('');

    const [ order ] = this.invoice.orders;
    return parseAccountingCost(order.accountingCost, order);
  }

  public get vatText() {
    return this.invoice.supplierParty.vatRegulation ? this.$t('Document.vat') : '';
  }
}
